import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const SUPPORTED_REGIONS = ['ma'] as const;
export type RegionCode = typeof SUPPORTED_REGIONS[number];
export const DEFAULT_REGION: RegionCode = 'ma';

export const SUPPORTED_REGION_SET = new Set<string>(SUPPORTED_REGIONS);

export function isSupportedRegion(region: string | null | undefined): region is RegionCode {
  if (!region) return false;
  return SUPPORTED_REGION_SET.has(region.toLowerCase());
}

export function extractRegionFromPath(pathname: string): RegionCode | null {
  const match = pathname.match(/^\/([a-z]{2})(?:\b|\/)/i);
  if (!match) return null;

  const region = match[1].toLowerCase();
  return isSupportedRegion(region) ? (region as RegionCode) : null;
}

export function buildRegionPath(region: RegionCode, path?: string): string {
  const suffix = path ? `/${path.replace(/^\//, '')}` : '';
  return `/${region}${suffix}`;
}

export function useActiveRegion(): RegionCode | null {
  const { pathname } = useLocation();

  return useMemo(() => {
    return extractRegionFromPath(pathname);
  }, [pathname]);
}
